export default __webpack_public_path__ + "static/media/influencer_card3.57779792.png";